import { render, staticRenderFns } from "./TenderSteps.vue?vue&type=template&id=37314c4c"
import script from "./TenderSteps.vue?vue&type=script&lang=js"
export * from "./TenderSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports